import { useEffect } from 'react';
/**
 *
 * helper hook to know if it's user clicks outside the element
 * src: https://hashnode.com/post/useonclickoutside-custom-hook-to-detect-the-mouse-click-on-outside-typescript-ckrejmy3h0k5r91s18iu42t28
 * @param ref - reference to the element
 * @param handler - function to execute every time user click outside
 */
export function useOnClickOutside(ref, handler) {
    useEffect(function () {
        var listener = function (event) {
            var element = ref === null || ref === void 0 ? void 0 : ref.current;
            if (!element || element.contains((event === null || event === void 0 ? void 0 : event.target) || null)) {
                return;
            }
            handler(event); // Call the handler only if the click is outside of the element passed.
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]); // Reload only if ref or handler changes
}
